







































































import {
  ref,
  defineComponent,
  toRefs,
  reactive,
  inject,
} from '@vue/composition-api'

import { changePassword, checkPassword } from '@/shared/api'
import { alertSymbol } from '@/shared/state-management/symbols'
import CloseButton from '@/components/custom/CloseButton.vue'

export default defineComponent({
  name: 'ChangePassword',
  components: {
    CloseButton,
  },
  props: {
    user: Object,
  },
  setup(props, { root, emit }) {
    const ChangePasswordForm = ref(null)
    const data = reactive({
      valid: true,
      currentPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      currentPasswordVisible: false,
      newPasswordVisible: false,
      newPasswordConfirmVisible: false,
      currentPasswordCorrect: false,
      currentPasswordChecked: false,
      checkingPassword: false,
    })

    const rules = reactive({
      newPasswordConfirmRules: [
        () => {
          return (
            data.newPasswordConfirm === data.newPassword ||
            root.$t('changePassword.newPasswordConfirmInvalid')
          )
        },
      ],
      newPasswordRules: [
        (v: string) =>
          (!!v && v.length >= 8) || root.$t('login.password.invalid_length'),
        (v: string) => {
          const result = v.match(/^.*(?=\S*[\W]).*$/)
          return (
            (result && result.length && result[0] !== '') ||
            root.$t('login.password.specialCharacter')
          )
        },
      ],
      currentPasswordRules: [
        (v: string) => !!v || root.$t('changePassword.passwordRequired'),
      ],
    })

    const loading = ref(false)
    const $alert = inject(alertSymbol) as Function

    const checkCurrentPassword = async (password: string) => {
      data.checkingPassword = true

      try {
        await checkPassword(password)
        data.currentPasswordCorrect = true
        data.checkingPassword = false
      } catch (e) {
        data.currentPasswordCorrect = false
        data.currentPasswordChecked = true
        data.checkingPassword = false
        throw e
      }
    }

    const submit = async () => {
      const form = ChangePasswordForm.value

      if (!(form.validate() && data.currentPasswordCorrect)) {
        return
      }
      loading.value = true
      try {
        await changePassword(data.currentPassword, data.newPassword)

        loading.value = false
        $alert({
          text: root.$t('changePassword.changedPasswordSuccess'),
          type: 'success',
        })
        emit('changed-password')
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    return {
      ...toRefs(data),
      ...toRefs(rules),
      loading,
      ChangePasswordForm,
      submit,
      checkCurrentPassword,
    }
  },
})
